import React, { Fragment, useEffect, useState } from 'react';
import { Autocomplete, Box, Button, CircularProgress, FormControl, IconButton, InputLabel, MenuItem, Paper, Popper, Select, TextField } from '@mui/material';
import EditIcon from "@mui/icons-material/Edit";
import ModalContainer from '../../../components/ModalContainer';
import Alert from '../../../utils/Alert';
import { contractorAssignmentService, getContractorDetailsService, getContractorListService } from '../../../services/usersServices';
import { useNavigate } from 'react-router-dom';

const ContractorAssignment = ({ rowData }) => { 
    const [open, setOpen] = useState(false);
    const [openSearchBox, setOpenSearchBox] = useState(false);
    const [contractorId, setContractorId] = useState(null);
    const [phaseId, setPhaseId] = useState(null);
    const [favoriteContractor, setFavoriteContractor] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingSearchBox, setLoadingSearchBox] = useState(false);
    const [loadingContractorDetail, setLoadingContractorDetail] = useState(false)
    const [options, setOptions] = useState([])
    const [contractorDetail, setContractorDetail] = useState(null)
    const navigate = useNavigate();

    const handleOpen = () => setOpen(true);
    const handleClose = async () => {
        setOpen(false);
        setOptions([]);
        setContractorId(null);
        setContractorDetail(null);
    }

    const handleCloseSearchBox = async () => {
        setOpenSearchBox(false);
        setOptions([]);
    };

    const handleChangeSearchBox = async (event, newValue) => {
        setContractorId("");
        setFavoriteContractor(newValue);
        await getContractorDetails(Number(newValue?.id));
    }

    const handleChangeAccepting = async (event) => {
        setFavoriteContractor(null);
        setContractorId(event.target.value);
        await getContractorDetails(Number(event.target.value));
    };


    const handleChangePhase = async (event) => {
        setPhaseId(event.target.value);
    };

    const handleOpenSearchBox = () => { 
        setOpenSearchBox(true);
        (async () => {
            setLoadingSearchBox(true);
            try {
                const response = await getContractorListService(rowData.code);
                if (response.status === 200) {
                    const data = response.data;
                    setOptions(prev => [...prev, ...data]);
                }
            }catch (error) {
                Alert("خطا!", "در بارگزاری پیمانکاران مشکلی رخ داده", "error");
            }finally {
                setLoadingSearchBox(false);
            }
        })();
    };

    const getContractorDetails = async (id) => {
        if (!id) {
            setContractorDetail(null);
            return;
        } 
        setLoadingContractorDetail(true);
        try {
            const response = await getContractorDetailsService(id);
            if (response.status === 200) {
                const data = response.data;
                setContractorDetail(data);
            }
        }catch (error) {
            Alert("خطا!", "مشکلی در بارگزاری جزئیات پیمانکار رخ داده است.", "error");
        }finally {
            setLoadingContractorDetail(false);
        }
    }

    const submit = async () => {
        let id;
        if (!contractorId && !favoriteContractor) {
            // Alert("خطا!", "لطفا یک پیمانکار را انتخاب کنید.", "error");
            // return;
            id = 0;
        }
        if (contractorId || favoriteContractor) {
            id = contractorId ? Number(contractorId) : Number(favoriteContractor.id);
        }
        if (id === rowData.contractor?.id) {
            Alert("خطا!", "این پیمانکار در حال حاضر به این سرویس اختصاص یافته است.", "error");
            return;
        }
        const data = {
            contractor_id: id,
            phase_id: Number(phaseId)
        }
        try {
            const response = await contractorAssignmentService(rowData.code, data);
            if (response.status === 200){
                handleClose();
                window.location.reload();
            }
        }catch (error) {
            Alert("خطا!", "در اختصاص پیمانکار مشکلی رخ داده است.", "error");
        }
    }


    return (
        <>
        <span>
            <IconButton
            onClick={handleOpen}
            disabled={!rowData.edit_is_enable}
            sx={{ mx: "0.25rem" }}
            >
                <EditIcon className={rowData.edit_is_enable ? "text-yellow-400" : "text-gray-300"} />
            </IconButton>
        </span>
        <ModalContainer
            alwaysOpen={false}
            onClose={handleClose}
            isOpen={open}
            title={"اختصاص پیمانکار"}
        >
            {loading ? (
                <div className="w-full flex flex-col 
                items-center justify-center
                px-3 py-10">
                    <CircularProgress size={50} />
                    <span className="text-primary mt-4 
                    text-xl opacity-animation">
                        صبر کنید...
                    </span>
                </div>
            ) : (
                <div>
                    <form class="w-full mx-auto mb-2">
                        <label for="phases" class="block mb-2 text-base font-medium text-gray-500">فازبندی پروژه:</label>
                        <select value={phaseId || ""} size="3" id="phases" onChange={handleChangePhase} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
                            <option selected value="">هیچکدام</option>
                            {rowData.phases.map((phase, index) => (
                                <option
                                    key={phase.id}
                                    value={phase.id}
                                >
                                    {phase.title}
                                </option>
                            ))}
                        </select>
                    </form>
                    <form class="w-full mx-auto">
                        <label for="contractors" class="block mb-2 text-base font-medium text-gray-500">درخواست پذیرش:</label>
                        <select value={contractorId || ""} size="3" id="contractors" onChange={handleChangeAccepting} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
                            <option selected value="">هیچکدام</option>
                            {rowData.petitioners.map((petitioner, index) => (
                                <option
                                    key={petitioner.id}
                                    value={petitioner.id}
                                >
                                    {petitioner.full_name}
                                </option>
                            ))}
                        </select>
                    </form>
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: 2 }}>  
                        <label for="contractorSearch" class="ml-2 text-right text-base text-gray-500">جستجوی پیمانکاران:</label>
                        <Autocomplete  
                            id='contractorSearch'
                            sx={{ flexGrow: 1 }} 
                            open={openSearchBox}  
                            value={favoriteContractor}
                            onOpen={handleOpenSearchBox}  
                            onClose={handleCloseSearchBox}  
                            isOptionEqualToValue={(option, value) => option.id === value.id}  
                            getOptionLabel={(option) => option.full_name}  
                            noOptionsText={"هیچ پیمانکاری با این نام وجود ندارد"}
                            loadingText={"در حال جستجو..."}
                            options={options}  
                            loading={loadingSearchBox}  
                            onChange={(event, newValue) => handleChangeSearchBox(event, newValue)}
                            PopperComponent={(props) => <Popper {...props} style={{ zIndex: 4000, width: props.anchorEl.clientWidth }} />}  
                            renderInput={(params) => (  
                                <TextField  
                                    {...params}  
                                    placeholder="جستجو در لیست پیمانکاران"
                                    slotProps={{  
                                        input: {  
                                            ...params.InputProps,  
                                            endAdornment: (  
                                                <Fragment>  
                                                    {loadingSearchBox ? <CircularProgress color="inherit" size={20} /> : null}  
                                                    {params.InputProps.endAdornment}  
                                                </Fragment>  
                                            ),  
                                        },  
                                    }}  
                                    fullWidth
                                    variant="outlined"
                                    sx={{ fontSize: '1rem' }}
                                />  
                            )}  
                        />  
                    </Box>  
                    <hr class="mt-5" />
                    {loadingContractorDetail ? (
                        <div className="w-full flex flex-col 
                        items-center justify-center
                        px-3 py-10">
                            <CircularProgress size={50} />
                            <span className="text-primary mt-4 
                            text-xl opacity-animation">
                                صبر کنید...
                            </span>
                        </div>
                    ) : (
                        <>
                        <p class="mt-5 text-base font-medium text-gray-500">اطلاعات پیمانکار:</p><br/>
                        <div class="grid grid-cols-3 gap-4">
                                <p class="text-base font-medium text-gray-900">نام: {contractorDetail?.full_name}</p>
                                <p class="text-base font-medium text-gray-900">موبایل: {contractorDetail?.phone_number}</p>
                            <p class="text-base font-medium text-gray-900">تلفن ثابت: {contractorDetail?.landline_number}</p>
                        </div>
                        <div class="grid grid-cols-2 gap-4 mt-5">
                            <p class="text-base font-medium text-gray-900">آدرس شرکت/کارگاه: {contractorDetail?.address}</p>
                            <p class="text-base font-medium text-gray-900">کد پستی: {contractorDetail?.postal_code}</p>
                        </div>
                        <hr class="mt-5" />
                        <p class="mt-5 text-base font-medium text-gray-500">سوابق پیمانکار:</p><br/>
                        <div class="grid grid-cols-4 gap-4">
                            <p class="text-base font-medium text-gray-900">تکمیل شده: {contractorDetail?.completed_service}</p>
                            <p class="text-base font-medium text-gray-900">در حال ساخت: {contractorDetail?.construction_service}</p>
                            <p class="text-base font-medium text-gray-900">انصراف: {contractorDetail?.canceled_service}</p>
                            <Button
                              variant="contained"
                              onClick={() =>
                                navigate(
                                    '/my-services', {
                                        state: { contractor: rowData.contractor || null }
                                    }
                                )
                              }
                            >
                                جزییات سوابق
                            </Button>
                            <p class="text-base font-medium text-gray-900">میانگین تاخیر: {contractorDetail ? contractorDetail.delay_average : 0}</p>
                            <p class="text-base font-medium text-gray-900">میانگین کیفیت: {contractorDetail ? contractorDetail.quality_average : 0}%</p>
                        </div>
                        </>
                    )}
                    <div class="mt-9 flex justify-center">
                        <Button
                            variant='contained'
                            sx={{ width: '30%' }}
                            onClick={submit}
                        >
                            تایید
                        </Button>
                    </div>
                </div>
            )}

        </ModalContainer>
        </>

    );
}

export default ContractorAssignment;
